import { API_BASE_URL, getUploadedImageUrl } from '../../../../api';
import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import maleHolder from "../../../../assets/SVG/user.svg";
import femaleHolder from "../../../../assets/SVG/femaleUser.svg";
import { jwtDecode } from "jwt-decode";
import { AccountContext } from '../../../../Contexts/main.context';

const EditMyAccount = () => {
     const { myAccount, updateMyAccount,updateActiveOutlet} = useContext(AccountContext);
     const fileInputRef = useRef();
     const navigate = useNavigate();

     const [formData, setFormData] = useState({
          displayName: myAccount.displayName || "",
          phone: myAccount.phone || "",
          myPicture: myAccount.myPicture || "",
          email: myAccount.email || "Not Editable",
          security: myAccount.security,
     });

     const [changePasswordMode, setChangePasswordMode] = useState(false);
     const [newPassword, setNewPassword] = useState("");

     useEffect(() => {
          if (myAccount) {
               setFormData({
                    displayName: myAccount.displayName || "",
                    phone: myAccount.phone || "",
                    iconSex: myAccount.iconSex || "Male",
                    accountSecurity: myAccount.security || "Not Set",
                    timesOn: myAccount.timesOn || 0,
                    idCode: myAccount.idCode || "",
                    myPicture: myAccount.myPicture || (myAccount.iconSex === "Female" ? femaleHolder : maleHolder),
                    email: myAccount.email || "Not Editable"
               });
          }
     }, [myAccount]);

     const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData((prev) => ({ ...prev, [name]: value }));
     };

     const handleImageClick = () => {
          fileInputRef.current.click();
     };

     const handleImageUpload = async (e) => {
          const file = e.target.files[0];
          if (!file) return;

          const formDataToSend = new FormData();
          formDataToSend.append("image", file);
          formDataToSend.append("script", "uploadUserPicture");
          formDataToSend.append("userID", myAccount.ID);

          try {
               const res = await fetch(API_BASE_URL + 'userImage.php', {
                    method: "POST",
                    body: formDataToSend,
               });

               const result = await res.json();
               if (!res.ok || result.status !== "success" || !result.imagePath || !result.token) {
                    throw new Error(result.message || "Failed to upload image.");
               }
               const updatedAccount = { ...myAccount, myPicture: result.imagePath };
               updateMyAccount(updatedAccount);
               localStorage.setItem("LGOUser", result.token);
               fileInputRef.current.value = null;

          } catch (err) {
               alert("Failed to upload image.");
          }
     };

     const handleClearPicture = async () => {
          const res = await fetch(API_BASE_URL + 'data.php', {
               method: "POST",
               headers: { "Content-Type": "application/json" },
               body: JSON.stringify({
                    script: "clearUserPicture",
                    userID: myAccount.ID,
               }),
          });

          const result = await res.json();

          if (result.status === "success") {

               const updatedAccount = { ...myAccount, myPicture: "" };
               updateMyAccount(updatedAccount);
               localStorage.setItem("LGOUser", result.token);
               // setFormData((prev) => ({
               //      ...prev,
               //      myPicture: "",
               // }));
               fileInputRef.current.value = null;
          } else {
               alert("Failed to clear picture.");
          }
     };


     const letsLogOut = () => {
          updateActiveOutlet(null);
          localStorage.removeItem("LGOUser");
          navigate('/login');
     }

     const handleSubmit = async (e) => {
          e.preventDefault();
          const sendData = {
               ...formData,
               ID: myAccount.ID,
               script: "updateMyAccount",
               ...(changePasswordMode && newPassword && { newPassword }),
          };

          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(sendData),
               });

               const data = await response.json();
               if (data.status === "success") {
                    localStorage.setItem("LGOUser", data.token);
                    const myNewAccount = jwtDecode(data.token);
                    updateMyAccount(myNewAccount);
                    setChangePasswordMode(false);
                    setNewPassword("");
               } else {
                    alert("Error saving client.");
               }
          } catch (error) {
               alert("An error occurred Saving Data");
          }
     };

     const letsChangePassword = async () => {
          if (!newPassword) {
               alert("Please enter a new password.");
               return;
          }
          const sendData = {
               "script": "updateMyPasswordAccount",
               ID: myAccount.ID,
               newPassword,
          };
          try {
               const response = await fetch(API_BASE_URL + 'data.php', {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(sendData),
               });
               const data = await response.json();
               if (data.status === "success") {
                    setChangePasswordMode(false);
                    setNewPassword("");
               } else {
                    alert("Error saving client.");
               }
          } catch (error) {
               alert("An error occurred Saving Data");
          }
     };

     // Determine the image source based on the conditions

     const getImageSrc = (myPicture) => {
          return getUploadedImageUrl(myPicture)
               ? getUploadedImageUrl(myPicture)
               : formData.iconSex === "Female"
                    ? femaleHolder
                    : maleHolder;
     };
     

     return (
          <div className="col-24 col-md-16 offset-md-16 offset-12 mt-4">
               <h3 className="text-center mb-1">Edit My Account</h3>
               <div className="fs-7 text-center mb-3">Press on Icon / Image to change your Profile Image</div>

               <div className="text-center mb-4">
                    <img
                         src={getImageSrc(myAccount.myPicture)}
                         alt="Profile"
                         onClick={handleImageClick}
                         style={{
                              width: "140px",
                              height: "140px",
                              borderRadius: "50%",
                              objectFit: "cover",
                              border: "3px solid navy",
                              cursor: "pointer",
                         }}
                    />
                    <input
                         type="file"
                         ref={fileInputRef}
                         onChange={handleImageUpload}
                         accept="image/*"
                         style={{ display: "none" }}
                    />
                    {formData.myPicture && (
                         <div className="mt-2">
                              <button className="btn btn-danger btn-sm" onClick={handleClearPicture}>
                                   Clear Profile Picture
                              </button>
                         </div>
                    )}
               </div>

               <form onSubmit={handleSubmit} className="bg-light p-4 border rounded">
                    <div className="mb-3 col-44 offset-2">
                         <label className="form-label">Display Name</label>
                         <input
                              type="text"
                              name="displayName"
                              value={formData.displayName}
                              onChange={handleChange}
                              className="form-control"
                              required
                         />
                    </div>

                    <div className="mb-3 col-44 offset-2">
                         <label className="form-label">Phone</label>
                         <input
                              type="text"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              className="form-control"
                         />
                    </div>

                    <div className="col-44 offset-2 mb-1">

                         <input
                              type="text"
                              value={formData.email}
                              className="form-control"
                              readOnly
                         />
                    </div>

                    <div className="col-44 offset-2 mb-3">
                         <input
                              type="text"
                              value={formData.accountSecurity}
                              className="form-control"
                              readOnly
                         />
                    </div>

                    {!changePasswordMode ? (
                         <div className="mb-3 col-44 offset-2">
                              <label className="form-label">Change Password</label>
                              <div
                                   className="btn btn-warning w-100"
                                   onClick={() => setChangePasswordMode(true)}
                              >
                                   Change Password
                              </div>
                         </div>
                    ) : (
                         <div className="col-44 offset-2 mb-3">
                              <label className="form-label text-danger">
                                   New Password <br />
                                   <span className="fs-8 text-dark">
                                        Remember to copy your new password for the next time you log in.
                                   </span>
                              </label>
                              <input
                                   type="text"
                                   className="form-control"
                                   value={newPassword}
                                   onChange={(e) => setNewPassword(e.target.value)}
                              />
                              <div className="d-flex justify-content-between mt-2">
                                   <div
                                        type="button"
                                        className="btn btn-danger"
                                        onClick={() => {
                                             setChangePasswordMode(false);
                                             setNewPassword("");
                                        }}
                                   >
                                        Cancel
                                   </div>
                                   <div className="btn btn-success text-light" onClick={() => letsChangePassword()}>
                                        Change Password
                                   </div>
                              </div>
                         </div>
                    )}

                    <div className="d-flex gap-3 justify-content-center mt-5">
                         <button
                              type="button"
                              className="btn btn-primary w-50 text-light"
                              onClick={letsLogOut}
                         >
                              Log Out
                         </button>
                         <button
                              type="submit"
                              className="btn btn-success w-50 text-light"
                         >
                              Save Changes
                         </button>
                    </div>
               </form>
          </div>
     );
};

export default EditMyAccount;
